/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HeaderSection from "../../common/headerSection";
import PageHeader from "../../common/pageHeader";
import ExposureDetailsLayout from "./partials/ExposureDetails";
import IncubationDetailsLayout from "./partials/IncubationDetail";
import AutoclaveDetailsLayout from "./partials/AutoclaveDetails";
import LabtestDetailsLayout from "./partials/LabtestDetails";
import Calendar from "../../../widgets/calendar";
import moment from "moment";
import { useTranslation } from "react-i18next";
import ExceptionDetailsLayout from "./partials/EceptionsDetails";
import HistoricalDashboard from "../historicalDashboard";
import { FaFilter } from "react-icons/fa";
import { BiFilterAlt } from "react-icons/bi";
import { dashboardServices } from "../../../service/dashboard";
import PlateReconciliation from "./partials/PlateRecoilination";
import DownloadPdf from "../../../widgets/downloadPdf";
import AlertModal from "../../../widgets/alertModal";
import { userService } from "../../../service/userService";
import InventryDetailsLayout from "./partials/inventryDetails";
import { LuActivity, LuAlertTriangle, LuArchive, LuBell, LuCheckCircle2, LuChevronRight, LuChevronsRight, LuClipboardList, LuClock, LuFileText, LuLayers, LuMicroscope, LuRefreshCw, LuRotateCcw, LuShieldAlert, LuThermometer } from "react-icons/lu";
import { Box } from "@mui/material";
import { KpiCardNew, SectionHeaderNew } from "./partials/KpiCardNew";

type ArrowValue = {
  exposed_plates: any;
  incubated_plates: any;
  lab_plates: any;
};

const Dashboard = () => {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState<string>("");
  const [endDate, setEndDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [tab, setTab] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [arrowValues, setArrowValues] = useState<ArrowValue[]>([]);
  const pipelineData = arrowValues?.[0];
  const [permission, setPermission] = useState<any>([]);


  const { t } = useTranslation();


  useEffect(() => {
    if (tab === "3") {
      // Analytics Dashboard
      navigate("/analytics-dashboard");
    }
    if (tab === "4") {
      // /Operator Schedule
      navigate("/operator-schedule");
    }
  }, [tab, navigate]);

  const getArrowCount = async () => {
    try {
      const response = await dashboardServices.getArrowCount();
      if (response.status && response.statusCode === 200) {
        try {
          if (response.data && typeof response.data === "object") {
            const {
              ready_for_incubation,
              ready_for_lab_test,
              ready_for_autoclave,
            } = response.data;

            const rowData: ArrowValue = {
              exposed_plates: ready_for_incubation,
              incubated_plates: ready_for_lab_test,
              lab_plates: ready_for_autoclave,
            };

            setArrowValues([rowData]);
          }
        } catch (error) {
          console.error(error);
        }
      } else {
        setArrowValues([]);
      }
    } catch (error) {
      console.error("exposure response", error);
    }
  };

  //get permission by role 
  const getPermissionByRole = async (role : number) => {
    try {
      const response = await userService.getPermissionByRole(role);
      if(response.status && response.statusCode === 200){
        setPermission(response.data.permissions)
        if(response.data.permissions.includes("realtime_dashboard")) {
          setTab("1")
        // } else if (response.data.permissions.includes("historical_dashboard")) {
        //   setTab("2")
         }else if (response.data.permissions.includes("analytics_dashboard")) {
          setTab("3")
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    var storedData = localStorage.getItem("userDetails");

    if (storedData) {
      var storedObject = JSON.parse(storedData);
      getPermissionByRole(storedObject[0].role_master_id);
    }
    getArrowCount();
  }, []);


  return (
    <div>
      <HeaderSection />
      <PageHeader pageHeader={t("dashboard.title")} pageDescription={t('pageDescription.dashboard.description')} />
      <div className="row realTimeAdminTab">
        <div className="col-10 d-flex">
          {permission?.includes("realtime_dashboard") && (
            <button
              onClick={() => setTab("1")}
              className={tab === "1" ? "colTabBtnSel" : "colTabBtn"}
            >
              {t("dashboard.realtime")}
            </button>
          )}
          {/* {permission?.includes("historical_dashboard") && (
            <button
              onClick={() => setTab("2")}
              className={tab === "2" ? "colTabBtnSel" : "colTabBtn"}
            >
              {t("dashboard.historical")}
            </button>
          )} */}

          {permission?.includes("analytics_dashboard") && (
            <button
              onClick={() => setTab("3")}
              className={tab === "3" ? "colTabBtnSel" : "colTabBtn"}
            >
              {t("dashboard.analyticalDashboard")}
            </button>
          )}
          {/* <button
            onClick={() => setTab("4")}
            className={tab === "4" ? "colTabBtnSel" : "colTabBtn"}
          >
            {t("dashboard.OperatorSchedule")}
          </button> */}
        </div>
        <div className="col-2 d-flex">
          {tab === "2" && (
            <BiFilterAlt
              onClick={() => setShowFilters(!showFilters)}
              fontSize={30}
              fill="black"
              className="mx-3 mt-2"
              title="Click here to show filter"
            />
            //  <button onClick={() => setShowFilters(!showFilters)} className='squareOrangeBtn3 my-2'> </button>
          )}
            <DownloadPdf divId="dashWrap" reportHead="Dashboard Report" />
        </div>
      </div>


{(tab === "1" && permission.includes("realtime_dashboard")) && (
  <div id="dashWrap">
   
          <InventryDetailsLayout
            selectedDate={selectedDate}
            heading={t("common.inventory")}
          />

          <div className="pe-4">
            <SectionHeaderNew title="Process Pipeline (Real-Time)" />
            <div className="flex flex-col md:flex-row items-stretch gap-4 lg:gap-8 justify-center">
              <KpiCardNew label="Ready For Incubation" val={pipelineData?.exposed_plates?.toLocaleString() || "0"} color="blue" icon={LuThermometer} layout="hero" className="h-[125px]" />
              <div className="hidden md:flex items-center">
                <LuChevronRight className="w-8 h-8 text-slate-300" />
              </div>
              <KpiCardNew label="Ready For Lab Test" val={pipelineData?.incubated_plates?.toLocaleString() || "0"} color="emerald" icon={LuMicroscope} layout="hero" className="h-[125px]" />
              <div className="hidden md:flex items-center">
                <LuChevronRight className="w-8 h-8 text-slate-300" />
              </div>
              <KpiCardNew label="Ready For Autoclave" val={pipelineData?.lab_plates?.toLocaleString() || "0"} color="orange" icon={LuRotateCcw} layout="hero" className="h-[125px]" />
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch pe-4">

            <ExposureDetailsLayout
              selectedDate={selectedDate}
              heading={t("common.activity_details")}
            />

            <IncubationDetailsLayout
              selectedDate={selectedDate}
              heading={t("common.incubation")}
            />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch pe-4">
            <LabtestDetailsLayout
              selectedDate={selectedDate}
              heading={t("common.lab_test")}
            />
            <AutoclaveDetailsLayout
              selectedDate={selectedDate}
              heading={t("common.auto_clave")}
            />
          </div>

          <ExceptionDetailsLayout
            selectedDate={selectedDate}
            heading={t("common.exceptions")}
          />
  </div>
)}

      {tab === "2" && (
        // historical dashboard
        <HistoricalDashboard showFilters={showFilters} />
      )}

    </div>
  );
};

export default Dashboard;
